var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "id": "new47"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("50 New Icons in 4.7")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-address-book fa-lg mt-4"
  }), _c('br'), _vm._v("address-book\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o fa-lg mt-4"
  }), _c('br'), _vm._v("address-book-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-address-card fa-lg mt-4"
  }), _c('br'), _vm._v("address-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-address-card-o fa-lg mt-4"
  }), _c('br'), _vm._v("address-card-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bandcamp fa-lg mt-4"
  }), _c('br'), _vm._v("bandcamp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bath fa-lg mt-4"
  }), _c('br'), _vm._v("bath\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bathtub fa-lg mt-4"
  }), _c('br'), _vm._v("bathtub "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-drivers-license fa-lg mt-4"
  }), _c('br'), _vm._v("drivers-license "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-drivers-license-o fa-lg mt-4"
  }), _c('br'), _vm._v("drivers-license-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eercast fa-lg mt-4"
  }), _c('br'), _vm._v("eercast\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-open fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-open-o fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-open-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-etsy fa-lg mt-4"
  }), _c('br'), _vm._v("etsy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-free-code-camp fa-lg mt-4"
  }), _c('br'), _vm._v("free-code-camp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-grav fa-lg mt-4"
  }), _c('br'), _vm._v("grav\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-handshake-o fa-lg mt-4"
  }), _c('br'), _vm._v("handshake-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-id-badge fa-lg mt-4"
  }), _c('br'), _vm._v("id-badge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-id-card fa-lg mt-4"
  }), _c('br'), _vm._v("id-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o fa-lg mt-4"
  }), _c('br'), _vm._v("id-card-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-imdb fa-lg mt-4"
  }), _c('br'), _vm._v("imdb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linode fa-lg mt-4"
  }), _c('br'), _vm._v("linode\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-meetup fa-lg mt-4"
  }), _c('br'), _vm._v("meetup\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-microchip fa-lg mt-4"
  }), _c('br'), _vm._v("microchip\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-podcast fa-lg mt-4"
  }), _c('br'), _vm._v("podcast\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-quora fa-lg mt-4"
  }), _c('br'), _vm._v("quora\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ravelry fa-lg mt-4"
  }), _c('br'), _vm._v("ravelry\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-s15 fa-lg mt-4"
  }), _c('br'), _vm._v("s15 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shower fa-lg mt-4"
  }), _c('br'), _vm._v("shower\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-snowflake-o fa-lg mt-4"
  }), _c('br'), _vm._v("snowflake-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-superpowers fa-lg mt-4"
  }), _c('br'), _vm._v("superpowers\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-telegram fa-lg mt-4"
  }), _c('br'), _vm._v("telegram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-0 fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-0 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-1 fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-2 fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-3 fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-4 fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-4 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-empty fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-empty\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-full fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-full\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-half fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-quarter fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-quarter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thermometer-three-quarters fa-lg mt-4"
  }), _c('br'), _vm._v("thermometer-three-quarters\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-rectangle fa-lg mt-4"
  }), _c('br'), _vm._v("times-rectangle "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-rectangle-o fa-lg mt-4"
  }), _c('br'), _vm._v("times-rectangle-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-circle fa-lg mt-4"
  }), _c('br'), _vm._v("user-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("user-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-lg mt-4"
  }), _c('br'), _vm._v("user-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vcard fa-lg mt-4"
  }), _c('br'), _vm._v("vcard "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vcard-o fa-lg mt-4"
  }), _c('br'), _vm._v("vcard-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-window-close fa-lg mt-4"
  }), _c('br'), _vm._v("window-close\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-window-close-o fa-lg mt-4"
  }), _c('br'), _vm._v("window-close-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-window-maximize fa-lg mt-4"
  }), _c('br'), _vm._v("window-maximize\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-window-minimize fa-lg mt-4"
  }), _c('br'), _vm._v("window-minimize\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-window-restore fa-lg mt-4"
  }), _c('br'), _vm._v("window-restore\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wpexplorer fa-lg mt-4"
  }), _c('br'), _vm._v("wpexplorer\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "new"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("20 New Icons in 4.5")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codiepie fa-lg mt-4"
  }), _c('br'), _vm._v("codiepie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edge fa-lg mt-4"
  }), _c('br'), _vm._v("edge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fort-awesome fa-lg mt-4"
  }), _c('br'), _vm._v("fort-awesome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hashtag fa-lg mt-4"
  }), _c('br'), _vm._v("hashtag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mixcloud fa-lg mt-4"
  }), _c('br'), _vm._v("mixcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-modx fa-lg mt-4"
  }), _c('br'), _vm._v("modx\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-percent fa-lg mt-4"
  }), _c('br'), _vm._v("percent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-product-hunt fa-lg mt-4"
  }), _c('br'), _vm._v("product-hunt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-alien fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-alien\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scribd fa-lg mt-4"
  }), _c('br'), _vm._v("scribd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usb fa-lg mt-4"
  }), _c('br'), _vm._v("usb\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "web-application"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-adjust fa-lg mt-4"
  }), _c('br'), _vm._v("adjust\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-lg mt-4"
  }), _c('br'), _vm._v("anchor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-archive fa-lg mt-4"
  }), _c('br'), _vm._v("archive\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-lg mt-4"
  }), _c('br'), _vm._v("area-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows fa-lg mt-4"
  }), _c('br'), _vm._v("arrows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-asterisk fa-lg mt-4"
  }), _c('br'), _vm._v("asterisk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-at fa-lg mt-4"
  }), _c('br'), _vm._v("at\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-automobile fa-lg mt-4"
  }), _c('br'), _vm._v("automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-balance-scale fa-lg mt-4"
  }), _c('br'), _vm._v("balance-scale\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ban fa-lg mt-4"
  }), _c('br'), _vm._v("ban\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bank fa-lg mt-4"
  }), _c('br'), _vm._v("bank "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-barcode fa-lg mt-4"
  }), _c('br'), _vm._v("barcode\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bars fa-lg mt-4"
  }), _c('br'), _vm._v("bars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-0 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-0 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-1 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-2 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-3 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-4 fa-lg mt-4"
  }), _c('br'), _vm._v("battery-4 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-empty fa-lg mt-4"
  }), _c('br'), _vm._v("battery-empty\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-full fa-lg mt-4"
  }), _c('br'), _vm._v("battery-full\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-half fa-lg mt-4"
  }), _c('br'), _vm._v("battery-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-quarter fa-lg mt-4"
  }), _c('br'), _vm._v("battery-quarter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-battery-three-quarters fa-lg mt-4"
  }), _c('br'), _vm._v("battery-three-quarters\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bed fa-lg mt-4"
  }), _c('br'), _vm._v("bed\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-beer fa-lg mt-4"
  }), _c('br'), _vm._v("beer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell fa-lg mt-4"
  }), _c('br'), _vm._v("bell\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-o fa-lg mt-4"
  }), _c('br'), _vm._v("bell-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash fa-lg mt-4"
  }), _c('br'), _vm._v("bell-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash-o fa-lg mt-4"
  }), _c('br'), _vm._v("bell-slash-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bicycle fa-lg mt-4"
  }), _c('br'), _vm._v("bicycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-binoculars fa-lg mt-4"
  }), _c('br'), _vm._v("binoculars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-lg mt-4"
  }), _c('br'), _vm._v("birthday-cake\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-lg mt-4"
  }), _c('br'), _vm._v("bolt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bomb fa-lg mt-4"
  }), _c('br'), _vm._v("bomb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-book fa-lg mt-4"
  }), _c('br'), _vm._v("book\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bookmark fa-lg mt-4"
  }), _c('br'), _vm._v("bookmark\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o fa-lg mt-4"
  }), _c('br'), _vm._v("bookmark-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-briefcase fa-lg mt-4"
  }), _c('br'), _vm._v("briefcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bug fa-lg mt-4"
  }), _c('br'), _vm._v("bug\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-building fa-lg mt-4"
  }), _c('br'), _vm._v("building\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-building-o fa-lg mt-4"
  }), _c('br'), _vm._v("building-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn fa-lg mt-4"
  }), _c('br'), _vm._v("bullhorn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bullseye fa-lg mt-4"
  }), _c('br'), _vm._v("bullseye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-lg mt-4"
  }), _c('br'), _vm._v("bus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cab fa-lg mt-4"
  }), _c('br'), _vm._v("cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calculator fa-lg mt-4"
  }), _c('br'), _vm._v("calculator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-lg mt-4"
  }), _c('br'), _vm._v("calendar\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-check-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-minus-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-minus-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-plus-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o fa-lg mt-4"
  }), _c('br'), _vm._v("calendar-times-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-camera fa-lg mt-4"
  }), _c('br'), _vm._v("camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-camera-retro fa-lg mt-4"
  }), _c('br'), _vm._v("camera-retro\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-car fa-lg mt-4"
  }), _c('br'), _vm._v("car\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cart-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("cart-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cart-plus fa-lg mt-4"
  }), _c('br'), _vm._v("cart-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc fa-lg mt-4"
  }), _c('br'), _vm._v("cc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-certificate fa-lg mt-4"
  }), _c('br'), _vm._v("certificate\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg mt-4"
  }), _c('br'), _vm._v("check\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg mt-4"
  }), _c('br'), _vm._v("check-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square fa-lg mt-4"
  }), _c('br'), _vm._v("check-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-child fa-lg mt-4"
  }), _c('br'), _vm._v("child\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-lg mt-4"
  }), _c('br'), _vm._v("circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o-notch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-thin fa-lg mt-4"
  }), _c('br'), _vm._v("circle-thin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-lg mt-4"
  }), _c('br'), _vm._v("clock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clone fa-lg mt-4"
  }), _c('br'), _vm._v("clone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg mt-4"
  }), _c('br'), _vm._v("close "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud fa-lg mt-4"
  }), _c('br'), _vm._v("cloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-lg mt-4"
  }), _c('br'), _vm._v("cloud-download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload fa-lg mt-4"
  }), _c('br'), _vm._v("cloud-upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-code fa-lg mt-4"
  }), _c('br'), _vm._v("code\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-code-fork fa-lg mt-4"
  }), _c('br'), _vm._v("code-fork\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-coffee fa-lg mt-4"
  }), _c('br'), _vm._v("coffee\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-lg mt-4"
  }), _c('br'), _vm._v("cog\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cogs fa-lg mt-4"
  }), _c('br'), _vm._v("cogs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comment fa-lg mt-4"
  }), _c('br'), _vm._v("comment\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comment-o fa-lg mt-4"
  }), _c('br'), _vm._v("comment-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-commenting fa-lg mt-4"
  }), _c('br'), _vm._v("commenting\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o fa-lg mt-4"
  }), _c('br'), _vm._v("commenting-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comments fa-lg mt-4"
  }), _c('br'), _vm._v("comments\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-comments-o fa-lg mt-4"
  }), _c('br'), _vm._v("comments-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-compass fa-lg mt-4"
  }), _c('br'), _vm._v("compass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-copyright fa-lg mt-4"
  }), _c('br'), _vm._v("copyright\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-creative-commons fa-lg mt-4"
  }), _c('br'), _vm._v("creative-commons\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-crop fa-lg mt-4"
  }), _c('br'), _vm._v("crop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-crosshairs fa-lg mt-4"
  }), _c('br'), _vm._v("crosshairs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cube fa-lg mt-4"
  }), _c('br'), _vm._v("cube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cubes fa-lg mt-4"
  }), _c('br'), _vm._v("cubes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cutlery fa-lg mt-4"
  }), _c('br'), _vm._v("cutlery\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-lg mt-4"
  }), _c('br'), _vm._v("dashboard "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-database fa-lg mt-4"
  }), _c('br'), _vm._v("database\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-desktop fa-lg mt-4"
  }), _c('br'), _vm._v("desktop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-diamond fa-lg mt-4"
  }), _c('br'), _vm._v("diamond\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("dot-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-download fa-lg mt-4"
  }), _c('br'), _vm._v("download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg mt-4"
  }), _c('br'), _vm._v("edit "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h fa-lg mt-4"
  }), _c('br'), _vm._v("ellipsis-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v fa-lg mt-4"
  }), _c('br'), _vm._v("ellipsis-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-lg mt-4"
  }), _c('br'), _vm._v("envelope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square fa-lg mt-4"
  }), _c('br'), _vm._v("envelope-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-lg mt-4"
  }), _c('br'), _vm._v("eraser\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg mt-4"
  }), _c('br'), _vm._v("exclamation-triangle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-external-link fa-lg mt-4"
  }), _c('br'), _vm._v("external-link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-external-link-square fa-lg mt-4"
  }), _c('br'), _vm._v("external-link-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eye fa-lg mt-4"
  }), _c('br'), _vm._v("eye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eye-slash fa-lg mt-4"
  }), _c('br'), _vm._v("eye-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eyedropper fa-lg mt-4"
  }), _c('br'), _vm._v("eyedropper\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fax fa-lg mt-4"
  }), _c('br'), _vm._v("fax\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-feed fa-lg mt-4"
  }), _c('br'), _vm._v("feed "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-female fa-lg mt-4"
  }), _c('br'), _vm._v("female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet fa-lg mt-4"
  }), _c('br'), _vm._v("fighter-jet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-archive-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-audio-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-code-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-excel-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-image-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-pdf-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-powerpoint-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-video-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-word-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-film fa-lg mt-4"
  }), _c('br'), _vm._v("film\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-filter fa-lg mt-4"
  }), _c('br'), _vm._v("filter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fire fa-lg mt-4"
  }), _c('br'), _vm._v("fire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fire-extinguisher fa-lg mt-4"
  }), _c('br'), _vm._v("fire-extinguisher\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag fa-lg mt-4"
  }), _c('br'), _vm._v("flag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag-checkered fa-lg mt-4"
  }), _c('br'), _vm._v("flag-checkered\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg mt-4"
  }), _c('br'), _vm._v("flag-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flash fa-lg mt-4"
  }), _c('br'), _vm._v("flash "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flask fa-lg mt-4"
  }), _c('br'), _vm._v("flask\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder fa-lg mt-4"
  }), _c('br'), _vm._v("folder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-o fa-lg mt-4"
  }), _c('br'), _vm._v("folder-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-open fa-lg mt-4"
  }), _c('br'), _vm._v("folder-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o fa-lg mt-4"
  }), _c('br'), _vm._v("folder-open-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-lg mt-4"
  }), _c('br'), _vm._v("frown-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-futbol-o fa-lg mt-4"
  }), _c('br'), _vm._v("futbol-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gamepad fa-lg mt-4"
  }), _c('br'), _vm._v("gamepad\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gavel fa-lg mt-4"
  }), _c('br'), _vm._v("gavel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gear fa-lg mt-4"
  }), _c('br'), _vm._v("gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gears fa-lg mt-4"
  }), _c('br'), _vm._v("gears "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gift fa-lg mt-4"
  }), _c('br'), _vm._v("gift\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-glass fa-lg mt-4"
  }), _c('br'), _vm._v("glass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-globe fa-lg mt-4"
  }), _c('br'), _vm._v("globe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap fa-lg mt-4"
  }), _c('br'), _vm._v("graduation-cap\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-group fa-lg mt-4"
  }), _c('br'), _vm._v("group "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-lizard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-paper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-peace-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-pointer-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-rock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-scissors-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-spock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hashtag fa-lg mt-4"
  }), _c('br'), _vm._v("hashtag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hdd-o fa-lg mt-4"
  }), _c('br'), _vm._v("hdd-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-headphones fa-lg mt-4"
  }), _c('br'), _vm._v("headphones\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart fa-lg mt-4"
  }), _c('br'), _vm._v("heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart-o fa-lg mt-4"
  }), _c('br'), _vm._v("heart-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat fa-lg mt-4"
  }), _c('br'), _vm._v("heartbeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-history fa-lg mt-4"
  }), _c('br'), _vm._v("history\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-home fa-lg mt-4"
  }), _c('br'), _vm._v("home\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hotel fa-lg mt-4"
  }), _c('br'), _vm._v("hotel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-1 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-2 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-3 fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-end fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-half fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-o fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-start fa-lg mt-4"
  }), _c('br'), _vm._v("hourglass-start\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-i-cursor fa-lg mt-4"
  }), _c('br'), _vm._v("i-cursor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-image fa-lg mt-4"
  }), _c('br'), _vm._v("image "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-lg mt-4"
  }), _c('br'), _vm._v("inbox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-industry fa-lg mt-4"
  }), _c('br'), _vm._v("industry\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-info fa-lg mt-4"
  }), _c('br'), _vm._v("info\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-lg mt-4"
  }), _c('br'), _vm._v("info-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-institution fa-lg mt-4"
  }), _c('br'), _vm._v("institution "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-key fa-lg mt-4"
  }), _c('br'), _vm._v("key\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-keyboard-o fa-lg mt-4"
  }), _c('br'), _vm._v("keyboard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-language fa-lg mt-4"
  }), _c('br'), _vm._v("language\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-laptop fa-lg mt-4"
  }), _c('br'), _vm._v("laptop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-leaf fa-lg mt-4"
  }), _c('br'), _vm._v("leaf\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-legal fa-lg mt-4"
  }), _c('br'), _vm._v("legal "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lemon-o fa-lg mt-4"
  }), _c('br'), _vm._v("lemon-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-level-down fa-lg mt-4"
  }), _c('br'), _vm._v("level-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-level-up fa-lg mt-4"
  }), _c('br'), _vm._v("level-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-bouy fa-lg mt-4"
  }), _c('br'), _vm._v("life-bouy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-buoy fa-lg mt-4"
  }), _c('br'), _vm._v("life-buoy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-ring fa-lg mt-4"
  }), _c('br'), _vm._v("life-ring\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-life-saver fa-lg mt-4"
  }), _c('br'), _vm._v("life-saver "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o fa-lg mt-4"
  }), _c('br'), _vm._v("lightbulb-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-lg mt-4"
  }), _c('br'), _vm._v("line-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg mt-4"
  }), _c('br'), _vm._v("location-arrow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-lg mt-4"
  }), _c('br'), _vm._v("lock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-magic fa-lg mt-4"
  }), _c('br'), _vm._v("magic\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-magnet fa-lg mt-4"
  }), _c('br'), _vm._v("magnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-forward fa-lg mt-4"
  }), _c('br'), _vm._v("mail-forward "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply fa-lg mt-4"
  }), _c('br'), _vm._v("mail-reply "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply-all fa-lg mt-4"
  }), _c('br'), _vm._v("mail-reply-all "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-male fa-lg mt-4"
  }), _c('br'), _vm._v("male\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map fa-lg mt-4"
  }), _c('br'), _vm._v("map\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-lg mt-4"
  }), _c('br'), _vm._v("map-marker\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-o fa-lg mt-4"
  }), _c('br'), _vm._v("map-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-pin fa-lg mt-4"
  }), _c('br'), _vm._v("map-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-lg mt-4"
  }), _c('br'), _vm._v("map-signs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-meh-o fa-lg mt-4"
  }), _c('br'), _vm._v("meh-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-microphone fa-lg mt-4"
  }), _c('br'), _vm._v("microphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-microphone-slash fa-lg mt-4"
  }), _c('br'), _vm._v("microphone-slash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus fa-lg mt-4"
  }), _c('br'), _vm._v("minus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle fa-lg mt-4"
  }), _c('br'), _vm._v("minus-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-lg mt-4"
  }), _c('br'), _vm._v("mobile\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone fa-lg mt-4"
  }), _c('br'), _vm._v("mobile-phone "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-money fa-lg mt-4"
  }), _c('br'), _vm._v("money\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-moon-o fa-lg mt-4"
  }), _c('br'), _vm._v("moon-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mortar-board fa-lg mt-4"
  }), _c('br'), _vm._v("mortar-board "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-lg mt-4"
  }), _c('br'), _vm._v("motorcycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mouse-pointer fa-lg mt-4"
  }), _c('br'), _vm._v("mouse-pointer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-music fa-lg mt-4"
  }), _c('br'), _vm._v("music\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-navicon fa-lg mt-4"
  }), _c('br'), _vm._v("navicon "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o fa-lg mt-4"
  }), _c('br'), _vm._v("newspaper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-object-group fa-lg mt-4"
  }), _c('br'), _vm._v("object-group\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-object-ungroup fa-lg mt-4"
  }), _c('br'), _vm._v("object-ungroup\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paint-brush fa-lg mt-4"
  }), _c('br'), _vm._v("paint-brush\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane fa-lg mt-4"
  }), _c('br'), _vm._v("paper-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o fa-lg mt-4"
  }), _c('br'), _vm._v("paper-plane-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paw fa-lg mt-4"
  }), _c('br'), _vm._v("paw\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil fa-lg mt-4"
  }), _c('br'), _vm._v("pencil\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square fa-lg mt-4"
  }), _c('br'), _vm._v("pencil-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("pencil-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-percent fa-lg mt-4"
  }), _c('br'), _vm._v("percent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-phone fa-lg mt-4"
  }), _c('br'), _vm._v("phone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-phone-square fa-lg mt-4"
  }), _c('br'), _vm._v("phone-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-photo fa-lg mt-4"
  }), _c('br'), _vm._v("photo "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("picture-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-lg mt-4"
  }), _c('br'), _vm._v("pie-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plane fa-lg mt-4"
  }), _c('br'), _vm._v("plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plug fa-lg mt-4"
  }), _c('br'), _vm._v("plug\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg mt-4"
  }), _c('br'), _vm._v("plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg mt-4"
  }), _c('br'), _vm._v("plus-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-power-off fa-lg mt-4"
  }), _c('br'), _vm._v("power-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-print fa-lg mt-4"
  }), _c('br'), _vm._v("print\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece fa-lg mt-4"
  }), _c('br'), _vm._v("puzzle-piece\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-qrcode fa-lg mt-4"
  }), _c('br'), _vm._v("qrcode\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-question fa-lg mt-4"
  }), _c('br'), _vm._v("question\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-lg mt-4"
  }), _c('br'), _vm._v("question-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-quote-left fa-lg mt-4"
  }), _c('br'), _vm._v("quote-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-quote-right fa-lg mt-4"
  }), _c('br'), _vm._v("quote-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-random fa-lg mt-4"
  }), _c('br'), _vm._v("random\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-recycle fa-lg mt-4"
  }), _c('br'), _vm._v("recycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg mt-4"
  }), _c('br'), _vm._v("refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-registered fa-lg mt-4"
  }), _c('br'), _vm._v("registered\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-remove fa-lg mt-4"
  }), _c('br'), _vm._v("remove "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reorder fa-lg mt-4"
  }), _c('br'), _vm._v("reorder "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reply fa-lg mt-4"
  }), _c('br'), _vm._v("reply\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reply-all fa-lg mt-4"
  }), _c('br'), _vm._v("reply-all\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-retweet fa-lg mt-4"
  }), _c('br'), _vm._v("retweet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-road fa-lg mt-4"
  }), _c('br'), _vm._v("road\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rocket fa-lg mt-4"
  }), _c('br'), _vm._v("rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rss fa-lg mt-4"
  }), _c('br'), _vm._v("rss\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rss-square fa-lg mt-4"
  }), _c('br'), _vm._v("rss-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search fa-lg mt-4"
  }), _c('br'), _vm._v("search\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search-minus fa-lg mt-4"
  }), _c('br'), _vm._v("search-minus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-search-plus fa-lg mt-4"
  }), _c('br'), _vm._v("search-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-send fa-lg mt-4"
  }), _c('br'), _vm._v("send "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-send-o fa-lg mt-4"
  }), _c('br'), _vm._v("send-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-server fa-lg mt-4"
  }), _c('br'), _vm._v("server\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share fa-lg mt-4"
  }), _c('br'), _vm._v("share\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("share-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shield fa-lg mt-4"
  }), _c('br'), _vm._v("shield\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ship fa-lg mt-4"
  }), _c('br'), _vm._v("ship\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart fa-lg mt-4"
  }), _c('br'), _vm._v("shopping-cart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-in fa-lg mt-4"
  }), _c('br'), _vm._v("sign-in\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-lg mt-4"
  }), _c('br'), _vm._v("sign-out\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-signal fa-lg mt-4"
  }), _c('br'), _vm._v("signal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sitemap fa-lg mt-4"
  }), _c('br'), _vm._v("sitemap\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sliders fa-lg mt-4"
  }), _c('br'), _vm._v("sliders\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-smile-o fa-lg mt-4"
  }), _c('br'), _vm._v("smile-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-soccer-ball-o fa-lg mt-4"
  }), _c('br'), _vm._v("soccer-ball-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort fa-lg mt-4"
  }), _c('br'), _vm._v("sort\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-alpha-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-alpha-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-amount-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-amount-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-down fa-lg mt-4"
  }), _c('br'), _vm._v("sort-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-numeric-asc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc fa-lg mt-4"
  }), _c('br'), _vm._v("sort-numeric-desc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sort-up fa-lg mt-4"
  }), _c('br'), _vm._v("sort-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle fa-lg mt-4"
  }), _c('br'), _vm._v("space-shuttle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg mt-4"
  }), _c('br'), _vm._v("spinner\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spoon fa-lg mt-4"
  }), _c('br'), _vm._v("spoon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square fa-lg mt-4"
  }), _c('br'), _vm._v("square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star fa-lg mt-4"
  }), _c('br'), _vm._v("star\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half fa-lg mt-4"
  }), _c('br'), _vm._v("star-half\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-empty fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-empty "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-full fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-full "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-half-o fa-lg mt-4"
  }), _c('br'), _vm._v("star-half-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-star-o fa-lg mt-4"
  }), _c('br'), _vm._v("star-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note fa-lg mt-4"
  }), _c('br'), _vm._v("sticky-note\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o fa-lg mt-4"
  }), _c('br'), _vm._v("sticky-note-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-street-view fa-lg mt-4"
  }), _c('br'), _vm._v("street-view\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-suitcase fa-lg mt-4"
  }), _c('br'), _vm._v("suitcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sun-o fa-lg mt-4"
  }), _c('br'), _vm._v("sun-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-support fa-lg mt-4"
  }), _c('br'), _vm._v("support "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tablet fa-lg mt-4"
  }), _c('br'), _vm._v("tablet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tachometer fa-lg mt-4"
  }), _c('br'), _vm._v("tachometer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tag fa-lg mt-4"
  }), _c('br'), _vm._v("tag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tags fa-lg mt-4"
  }), _c('br'), _vm._v("tags\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tasks fa-lg mt-4"
  }), _c('br'), _vm._v("tasks\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-taxi fa-lg mt-4"
  }), _c('br'), _vm._v("taxi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-television fa-lg mt-4"
  }), _c('br'), _vm._v("television\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-terminal fa-lg mt-4"
  }), _c('br'), _vm._v("terminal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack fa-lg mt-4"
  }), _c('br'), _vm._v("thumb-tack\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ticket fa-lg mt-4"
  }), _c('br'), _vm._v("ticket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg mt-4"
  }), _c('br'), _vm._v("times\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-lg mt-4"
  }), _c('br'), _vm._v("times-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("times-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tint fa-lg mt-4"
  }), _c('br'), _vm._v("tint\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-off fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-on fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-on\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trademark fa-lg mt-4"
  }), _c('br'), _vm._v("trademark\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg mt-4"
  }), _c('br'), _vm._v("trash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trash-o fa-lg mt-4"
  }), _c('br'), _vm._v("trash-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tree fa-lg mt-4"
  }), _c('br'), _vm._v("tree\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trophy fa-lg mt-4"
  }), _c('br'), _vm._v("trophy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-lg mt-4"
  }), _c('br'), _vm._v("truck\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tty fa-lg mt-4"
  }), _c('br'), _vm._v("tty\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tv fa-lg mt-4"
  }), _c('br'), _vm._v("tv "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-umbrella fa-lg mt-4"
  }), _c('br'), _vm._v("umbrella\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-university fa-lg mt-4"
  }), _c('br'), _vm._v("university\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlock fa-lg mt-4"
  }), _c('br'), _vm._v("unlock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt fa-lg mt-4"
  }), _c('br'), _vm._v("unlock-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unsorted fa-lg mt-4"
  }), _c('br'), _vm._v("unsorted "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-upload fa-lg mt-4"
  }), _c('br'), _vm._v("upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user fa-lg mt-4"
  }), _c('br'), _vm._v("user\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-plus fa-lg mt-4"
  }), _c('br'), _vm._v("user-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-secret fa-lg mt-4"
  }), _c('br'), _vm._v("user-secret\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-times fa-lg mt-4"
  }), _c('br'), _vm._v("user-times\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-users fa-lg mt-4"
  }), _c('br'), _vm._v("users\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-video-camera fa-lg mt-4"
  }), _c('br'), _vm._v("video-camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-down fa-lg mt-4"
  }), _c('br'), _vm._v("volume-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-off fa-lg mt-4"
  }), _c('br'), _vm._v("volume-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-volume-up fa-lg mt-4"
  }), _c('br'), _vm._v("volume-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-lg mt-4"
  }), _c('br'), _vm._v("warning "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wifi fa-lg mt-4"
  }), _c('br'), _vm._v("wifi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-lg mt-4"
  }), _c('br'), _vm._v("wrench\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "hand"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-lizard-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-paper-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-peace-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-pointer-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-rock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-scissors-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-spock-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o fa-lg mt-4"
  }), _c('br'), _vm._v("hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up fa-lg mt-4"
  }), _c('br'), _vm._v("thumbs-up\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "transportation"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-lg mt-4"
  }), _c('br'), _vm._v("ambulance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-automobile fa-lg mt-4"
  }), _c('br'), _vm._v("automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bicycle fa-lg mt-4"
  }), _c('br'), _vm._v("bicycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-lg mt-4"
  }), _c('br'), _vm._v("bus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cab fa-lg mt-4"
  }), _c('br'), _vm._v("cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-car fa-lg mt-4"
  }), _c('br'), _vm._v("car\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet fa-lg mt-4"
  }), _c('br'), _vm._v("fighter-jet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle fa-lg mt-4"
  }), _c('br'), _vm._v("motorcycle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plane fa-lg mt-4"
  }), _c('br'), _vm._v("plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rocket fa-lg mt-4"
  }), _c('br'), _vm._v("rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ship fa-lg mt-4"
  }), _c('br'), _vm._v("ship\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle fa-lg mt-4"
  }), _c('br'), _vm._v("space-shuttle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-subway fa-lg mt-4"
  }), _c('br'), _vm._v("subway\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-taxi fa-lg mt-4"
  }), _c('br'), _vm._v("taxi\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-train fa-lg mt-4"
  }), _c('br'), _vm._v("train\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-truck fa-lg mt-4"
  }), _c('br'), _vm._v("truck\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "gender"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-genderless fa-lg mt-4"
  }), _c('br'), _vm._v("genderless\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-intersex fa-lg mt-4"
  }), _c('br'), _vm._v("intersex "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars fa-lg mt-4"
  }), _c('br'), _vm._v("mars\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-double fa-lg mt-4"
  }), _c('br'), _vm._v("mars-double\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-h fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-v fa-lg mt-4"
  }), _c('br'), _vm._v("mars-stroke-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mercury fa-lg mt-4"
  }), _c('br'), _vm._v("mercury\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-neuter fa-lg mt-4"
  }), _c('br'), _vm._v("neuter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-transgender fa-lg mt-4"
  }), _c('br'), _vm._v("transgender\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-transgender-alt fa-lg mt-4"
  }), _c('br'), _vm._v("transgender-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus fa-lg mt-4"
  }), _c('br'), _vm._v("venus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus-double fa-lg mt-4"
  }), _c('br'), _vm._v("venus-double\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-venus-mars fa-lg mt-4"
  }), _c('br'), _vm._v("venus-mars\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "file-type"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file fa-lg mt-4"
  }), _c('br'), _vm._v("file\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-archive-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-audio-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-code-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-excel-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-image-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-pdf-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-powerpoint-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text fa-lg mt-4"
  }), _c('br'), _vm._v("file-text\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-text-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-video-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-word-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "spinner"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('ul', {
    staticClass: "fa-ul"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-info-circle fa-li"
  }), _vm._v("\n            These icons work great with the "), _c('code', [_vm._v("fa-spin")]), _vm._v(" class.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o-notch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cog fa-lg mt-4"
  }), _c('br'), _vm._v("cog\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gear fa-lg mt-4"
  }), _c('br'), _vm._v("gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg mt-4"
  }), _c('br'), _vm._v("refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-lg mt-4"
  }), _c('br'), _vm._v("spinner\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "form-control"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square fa-lg mt-4"
  }), _c('br'), _vm._v("check-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("check-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-lg mt-4"
  }), _c('br'), _vm._v("circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("dot-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("minus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square fa-lg mt-4"
  }), _c('br'), _vm._v("square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-square-o fa-lg mt-4"
  }), _c('br'), _vm._v("square-o\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "payment"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex fa-lg mt-4"
  }), _c('br'), _vm._v("cc-amex\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club fa-lg mt-4"
  }), _c('br'), _vm._v("cc-diners-club\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover fa-lg mt-4"
  }), _c('br'), _vm._v("cc-discover\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb fa-lg mt-4"
  }), _c('br'), _vm._v("cc-jcb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard fa-lg mt-4"
  }), _c('br'), _vm._v("cc-mastercard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("cc-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe fa-lg mt-4"
  }), _c('br'), _vm._v("cc-stripe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa fa-lg mt-4"
  }), _c('br'), _vm._v("cc-visa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt fa-lg mt-4"
  }), _c('br'), _vm._v("credit-card-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet fa-lg mt-4"
  }), _c('br'), _vm._v("google-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("paypal\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "chart"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-area-chart fa-lg mt-4"
  }), _c('br'), _vm._v("area-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o fa-lg mt-4"
  }), _c('br'), _vm._v("bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-lg mt-4"
  }), _c('br'), _vm._v("line-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-lg mt-4"
  }), _c('br'), _vm._v("pie-chart\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "currency"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin fa-lg mt-4"
  }), _c('br'), _vm._v("bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-btc fa-lg mt-4"
  }), _c('br'), _vm._v("btc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cny fa-lg mt-4"
  }), _c('br'), _vm._v("cny "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dollar fa-lg mt-4"
  }), _c('br'), _vm._v("dollar "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eur fa-lg mt-4"
  }), _c('br'), _vm._v("eur\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-euro fa-lg mt-4"
  }), _c('br'), _vm._v("euro "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gbp fa-lg mt-4"
  }), _c('br'), _vm._v("gbp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg fa-lg mt-4"
  }), _c('br'), _vm._v("gg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle fa-lg mt-4"
  }), _c('br'), _vm._v("gg-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ils fa-lg mt-4"
  }), _c('br'), _vm._v("ils\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-inr fa-lg mt-4"
  }), _c('br'), _vm._v("inr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-jpy fa-lg mt-4"
  }), _c('br'), _vm._v("jpy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-krw fa-lg mt-4"
  }), _c('br'), _vm._v("krw\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-money fa-lg mt-4"
  }), _c('br'), _vm._v("money\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rmb fa-lg mt-4"
  }), _c('br'), _vm._v("rmb "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rouble fa-lg mt-4"
  }), _c('br'), _vm._v("rouble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rub fa-lg mt-4"
  }), _c('br'), _vm._v("rub\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ruble fa-lg mt-4"
  }), _c('br'), _vm._v("ruble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rupee fa-lg mt-4"
  }), _c('br'), _vm._v("rupee "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shekel fa-lg mt-4"
  }), _c('br'), _vm._v("shekel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sheqel fa-lg mt-4"
  }), _c('br'), _vm._v("sheqel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-try fa-lg mt-4"
  }), _c('br'), _vm._v("try\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-turkish-lira fa-lg mt-4"
  }), _c('br'), _vm._v("turkish-lira "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usd fa-lg mt-4"
  }), _c('br'), _vm._v("usd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-won fa-lg mt-4"
  }), _c('br'), _vm._v("won "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yen fa-lg mt-4"
  }), _c('br'), _vm._v("yen "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "text-editor"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-center fa-lg mt-4"
  }), _c('br'), _vm._v("align-center\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-justify fa-lg mt-4"
  }), _c('br'), _vm._v("align-justify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-left fa-lg mt-4"
  }), _c('br'), _vm._v("align-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-align-right fa-lg mt-4"
  }), _c('br'), _vm._v("align-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bold fa-lg mt-4"
  }), _c('br'), _vm._v("bold\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chain fa-lg mt-4"
  }), _c('br'), _vm._v("chain "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chain-broken fa-lg mt-4"
  }), _c('br'), _vm._v("chain-broken\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-clipboard fa-lg mt-4"
  }), _c('br'), _vm._v("clipboard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-columns fa-lg mt-4"
  }), _c('br'), _vm._v("columns\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-copy fa-lg mt-4"
  }), _c('br'), _vm._v("copy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cut fa-lg mt-4"
  }), _c('br'), _vm._v("cut "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dedent fa-lg mt-4"
  }), _c('br'), _vm._v("dedent "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eraser fa-lg mt-4"
  }), _c('br'), _vm._v("eraser\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file fa-lg mt-4"
  }), _c('br'), _vm._v("file\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text fa-lg mt-4"
  }), _c('br'), _vm._v("file-text\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o fa-lg mt-4"
  }), _c('br'), _vm._v("file-text-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-files-o fa-lg mt-4"
  }), _c('br'), _vm._v("files-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o fa-lg mt-4"
  }), _c('br'), _vm._v("floppy-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-font fa-lg mt-4"
  }), _c('br'), _vm._v("font\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-header fa-lg mt-4"
  }), _c('br'), _vm._v("header\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-indent fa-lg mt-4"
  }), _c('br'), _vm._v("indent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-italic fa-lg mt-4"
  }), _c('br'), _vm._v("italic\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-link fa-lg mt-4"
  }), _c('br'), _vm._v("link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list fa-lg mt-4"
  }), _c('br'), _vm._v("list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg mt-4"
  }), _c('br'), _vm._v("list-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-ol fa-lg mt-4"
  }), _c('br'), _vm._v("list-ol\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-list-ul fa-lg mt-4"
  }), _c('br'), _vm._v("list-ul\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-outdent fa-lg mt-4"
  }), _c('br'), _vm._v("outdent\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paperclip fa-lg mt-4"
  }), _c('br'), _vm._v("paperclip\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paragraph fa-lg mt-4"
  }), _c('br'), _vm._v("paragraph\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paste fa-lg mt-4"
  }), _c('br'), _vm._v("paste "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-lg mt-4"
  }), _c('br'), _vm._v("repeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rotate-left fa-lg mt-4"
  }), _c('br'), _vm._v("rotate-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rotate-right fa-lg mt-4"
  }), _c('br'), _vm._v("rotate-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-save fa-lg mt-4"
  }), _c('br'), _vm._v("save "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scissors fa-lg mt-4"
  }), _c('br'), _vm._v("scissors\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-strikethrough fa-lg mt-4"
  }), _c('br'), _vm._v("strikethrough\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-subscript fa-lg mt-4"
  }), _c('br'), _vm._v("subscript\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-superscript fa-lg mt-4"
  }), _c('br'), _vm._v("superscript\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-table fa-lg mt-4"
  }), _c('br'), _vm._v("table\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-text-height fa-lg mt-4"
  }), _c('br'), _vm._v("text-height\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-text-width fa-lg mt-4"
  }), _c('br'), _vm._v("text-width\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th fa-lg mt-4"
  }), _c('br'), _vm._v("th\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th-large fa-lg mt-4"
  }), _c('br'), _vm._v("th-large\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-th-list fa-lg mt-4"
  }), _c('br'), _vm._v("th-list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-underline fa-lg mt-4"
  }), _c('br'), _vm._v("underline\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-undo fa-lg mt-4"
  }), _c('br'), _vm._v("undo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-unlink fa-lg mt-4"
  }), _c('br'), _vm._v("unlink "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "directional"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-lg mt-4"
  }), _c('br'), _vm._v("angle-double-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-down fa-lg mt-4"
  }), _c('br'), _vm._v("angle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-lg mt-4"
  }), _c('br'), _vm._v("angle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-lg mt-4"
  }), _c('br'), _vm._v("angle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angle-up fa-lg mt-4"
  }), _c('br'), _vm._v("angle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-circle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up fa-lg mt-4"
  }), _c('br'), _vm._v("arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows fa-lg mt-4"
  }), _c('br'), _vm._v("arrows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-h\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-v\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-square-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-lg mt-4"
  }), _c('br'), _vm._v("caret-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-right fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-up fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-circle-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-down fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chevron-up fa-lg mt-4"
  }), _c('br'), _vm._v("chevron-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up fa-lg mt-4"
  }), _c('br'), _vm._v("hand-o-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-down fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-right fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up fa-lg mt-4"
  }), _c('br'), _vm._v("long-arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up fa-lg mt-4"
  }), _c('br'), _vm._v("toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "video-player"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-lg mt-4"
  }), _c('br'), _vm._v("arrows-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-backward fa-lg mt-4"
  }), _c('br'), _vm._v("backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-compress fa-lg mt-4"
  }), _c('br'), _vm._v("compress\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-eject fa-lg mt-4"
  }), _c('br'), _vm._v("eject\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-expand fa-lg mt-4"
  }), _c('br'), _vm._v("expand\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fast-backward fa-lg mt-4"
  }), _c('br'), _vm._v("fast-backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fast-forward fa-lg mt-4"
  }), _c('br'), _vm._v("fast-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-forward fa-lg mt-4"
  }), _c('br'), _vm._v("forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause fa-lg mt-4"
  }), _c('br'), _vm._v("pause\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pause-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("pause-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play fa-lg mt-4"
  }), _c('br'), _vm._v("play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play-circle fa-lg mt-4"
  }), _c('br'), _vm._v("play-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("play-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-random fa-lg mt-4"
  }), _c('br'), _vm._v("random\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-step-backward fa-lg mt-4"
  }), _c('br'), _vm._v("step-backward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-step-forward fa-lg mt-4"
  }), _c('br'), _vm._v("step-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop fa-lg mt-4"
  }), _c('br'), _vm._v("stop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle-o fa-lg mt-4"
  }), _c('br'), _vm._v("stop-circle-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-play\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Warning!")]), _vm._v("\n        Apparently, Adblock Plus can remove Font Awesome brand icons with their \"Remove Social\n        Media Buttons\" setting. We will not use hacks to force them to display. Please\n        "), _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": "https://adblockplus.org/en/bugs"
    }
  }, [_vm._v("report an issue with Adblock Plus")]), _vm._v(" if you believe this to be\n        an error. To work around this, you'll need to modify the social icon class names.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-500px fa-lg mt-4"
  }), _c('br'), _vm._v("500px\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-adn fa-lg mt-4"
  }), _c('br'), _vm._v("adn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-amazon fa-lg mt-4"
  }), _c('br'), _vm._v("amazon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-android fa-lg mt-4"
  }), _c('br'), _vm._v("android\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-angellist fa-lg mt-4"
  }), _c('br'), _vm._v("angellist\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-apple fa-lg mt-4"
  }), _c('br'), _vm._v("apple\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-behance fa-lg mt-4"
  }), _c('br'), _vm._v("behance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-behance-square fa-lg mt-4"
  }), _c('br'), _vm._v("behance-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket fa-lg mt-4"
  }), _c('br'), _vm._v("bitbucket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket-square fa-lg mt-4"
  }), _c('br'), _vm._v("bitbucket-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin fa-lg mt-4"
  }), _c('br'), _vm._v("bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-black-tie fa-lg mt-4"
  }), _c('br'), _vm._v("black-tie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-bluetooth-b fa-lg mt-4"
  }), _c('br'), _vm._v("bluetooth-b\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-btc fa-lg mt-4"
  }), _c('br'), _vm._v("btc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-buysellads fa-lg mt-4"
  }), _c('br'), _vm._v("buysellads\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex fa-lg mt-4"
  }), _c('br'), _vm._v("cc-amex\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club fa-lg mt-4"
  }), _c('br'), _vm._v("cc-diners-club\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover fa-lg mt-4"
  }), _c('br'), _vm._v("cc-discover\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb fa-lg mt-4"
  }), _c('br'), _vm._v("cc-jcb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard fa-lg mt-4"
  }), _c('br'), _vm._v("cc-mastercard\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("cc-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe fa-lg mt-4"
  }), _c('br'), _vm._v("cc-stripe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa fa-lg mt-4"
  }), _c('br'), _vm._v("cc-visa\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-chrome fa-lg mt-4"
  }), _c('br'), _vm._v("chrome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codepen fa-lg mt-4"
  }), _c('br'), _vm._v("codepen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-codiepie fa-lg mt-4"
  }), _c('br'), _vm._v("codiepie\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-connectdevelop fa-lg mt-4"
  }), _c('br'), _vm._v("connectdevelop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-contao fa-lg mt-4"
  }), _c('br'), _vm._v("contao\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-css3 fa-lg mt-4"
  }), _c('br'), _vm._v("css3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dashcube fa-lg mt-4"
  }), _c('br'), _vm._v("dashcube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-delicious fa-lg mt-4"
  }), _c('br'), _vm._v("delicious\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-deviantart fa-lg mt-4"
  }), _c('br'), _vm._v("deviantart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-digg fa-lg mt-4"
  }), _c('br'), _vm._v("digg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dribbble fa-lg mt-4"
  }), _c('br'), _vm._v("dribbble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-dropbox fa-lg mt-4"
  }), _c('br'), _vm._v("dropbox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-drupal fa-lg mt-4"
  }), _c('br'), _vm._v("drupal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-edge fa-lg mt-4"
  }), _c('br'), _vm._v("edge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-empire fa-lg mt-4"
  }), _c('br'), _vm._v("empire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-expeditedssl fa-lg mt-4"
  }), _c('br'), _vm._v("expeditedssl\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-lg mt-4"
  }), _c('br'), _vm._v("facebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-f fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-f "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-official fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-official\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-lg mt-4"
  }), _c('br'), _vm._v("facebook-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-firefox fa-lg mt-4"
  }), _c('br'), _vm._v("firefox\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-flickr fa-lg mt-4"
  }), _c('br'), _vm._v("flickr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fonticons fa-lg mt-4"
  }), _c('br'), _vm._v("fonticons\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-fort-awesome fa-lg mt-4"
  }), _c('br'), _vm._v("fort-awesome\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-forumbee fa-lg mt-4"
  }), _c('br'), _vm._v("forumbee\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-foursquare fa-lg mt-4"
  }), _c('br'), _vm._v("foursquare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ge fa-lg mt-4"
  }), _c('br'), _vm._v("ge "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-get-pocket fa-lg mt-4"
  }), _c('br'), _vm._v("get-pocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg fa-lg mt-4"
  }), _c('br'), _vm._v("gg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle fa-lg mt-4"
  }), _c('br'), _vm._v("gg-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-git fa-lg mt-4"
  }), _c('br'), _vm._v("git\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-git-square fa-lg mt-4"
  }), _c('br'), _vm._v("git-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github fa-lg mt-4"
  }), _c('br'), _vm._v("github\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github-alt fa-lg mt-4"
  }), _c('br'), _vm._v("github-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-github-square fa-lg mt-4"
  }), _c('br'), _vm._v("github-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gittip fa-lg mt-4"
  }), _c('br'), _vm._v("gittip "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google fa-lg mt-4"
  }), _c('br'), _vm._v("google\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-plus fa-lg mt-4"
  }), _c('br'), _vm._v("google-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("google-plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet fa-lg mt-4"
  }), _c('br'), _vm._v("google-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-gratipay fa-lg mt-4"
  }), _c('br'), _vm._v("gratipay\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hacker-news fa-lg mt-4"
  }), _c('br'), _vm._v("hacker-news\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-houzz fa-lg mt-4"
  }), _c('br'), _vm._v("houzz\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-html5 fa-lg mt-4"
  }), _c('br'), _vm._v("html5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-lg mt-4"
  }), _c('br'), _vm._v("instagram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-internet-explorer fa-lg mt-4"
  }), _c('br'), _vm._v("internet-explorer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ioxhost fa-lg mt-4"
  }), _c('br'), _vm._v("ioxhost\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-joomla fa-lg mt-4"
  }), _c('br'), _vm._v("joomla\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-jsfiddle fa-lg mt-4"
  }), _c('br'), _vm._v("jsfiddle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lastfm fa-lg mt-4"
  }), _c('br'), _vm._v("lastfm\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-lastfm-square fa-lg mt-4"
  }), _c('br'), _vm._v("lastfm-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-leanpub fa-lg mt-4"
  }), _c('br'), _vm._v("leanpub\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-lg mt-4"
  }), _c('br'), _vm._v("linkedin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square fa-lg mt-4"
  }), _c('br'), _vm._v("linkedin-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-linux fa-lg mt-4"
  }), _c('br'), _vm._v("linux\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-maxcdn fa-lg mt-4"
  }), _c('br'), _vm._v("maxcdn\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-meanpath fa-lg mt-4"
  }), _c('br'), _vm._v("meanpath\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-medium fa-lg mt-4"
  }), _c('br'), _vm._v("medium\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-mixcloud fa-lg mt-4"
  }), _c('br'), _vm._v("mixcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-modx fa-lg mt-4"
  }), _c('br'), _vm._v("modx\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki fa-lg mt-4"
  }), _c('br'), _vm._v("odnoklassniki\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki-square fa-lg mt-4"
  }), _c('br'), _vm._v("odnoklassniki-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-opencart fa-lg mt-4"
  }), _c('br'), _vm._v("opencart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-openid fa-lg mt-4"
  }), _c('br'), _vm._v("openid\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-opera fa-lg mt-4"
  }), _c('br'), _vm._v("opera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-optin-monster fa-lg mt-4"
  }), _c('br'), _vm._v("optin-monster\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pagelines fa-lg mt-4"
  }), _c('br'), _vm._v("pagelines\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-paypal fa-lg mt-4"
  }), _c('br'), _vm._v("paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper fa-lg mt-4"
  }), _c('br'), _vm._v("pied-piper\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper-alt fa-lg mt-4"
  }), _c('br'), _vm._v("pied-piper-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-p fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest-p\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-square fa-lg mt-4"
  }), _c('br'), _vm._v("pinterest-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-product-hunt fa-lg mt-4"
  }), _c('br'), _vm._v("product-hunt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-qq fa-lg mt-4"
  }), _c('br'), _vm._v("qq\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ra fa-lg mt-4"
  }), _c('br'), _vm._v("ra "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-rebel fa-lg mt-4"
  }), _c('br'), _vm._v("rebel\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit fa-lg mt-4"
  }), _c('br'), _vm._v("reddit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-alien fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-alien\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-reddit-square fa-lg mt-4"
  }), _c('br'), _vm._v("reddit-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-renren fa-lg mt-4"
  }), _c('br'), _vm._v("renren\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-safari fa-lg mt-4"
  }), _c('br'), _vm._v("safari\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-scribd fa-lg mt-4"
  }), _c('br'), _vm._v("scribd\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-sellsy fa-lg mt-4"
  }), _c('br'), _vm._v("sellsy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square fa-lg mt-4"
  }), _c('br'), _vm._v("share-alt-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-shirtsinbulk fa-lg mt-4"
  }), _c('br'), _vm._v("shirtsinbulk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-simplybuilt fa-lg mt-4"
  }), _c('br'), _vm._v("simplybuilt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-skyatlas fa-lg mt-4"
  }), _c('br'), _vm._v("skyatlas\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-skype fa-lg mt-4"
  }), _c('br'), _vm._v("skype\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-slack fa-lg mt-4"
  }), _c('br'), _vm._v("slack\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-slideshare fa-lg mt-4"
  }), _c('br'), _vm._v("slideshare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud fa-lg mt-4"
  }), _c('br'), _vm._v("soundcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-spotify fa-lg mt-4"
  }), _c('br'), _vm._v("spotify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stack-exchange fa-lg mt-4"
  }), _c('br'), _vm._v("stack-exchange\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-lg mt-4"
  }), _c('br'), _vm._v("stack-overflow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-steam fa-lg mt-4"
  }), _c('br'), _vm._v("steam\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-steam-square fa-lg mt-4"
  }), _c('br'), _vm._v("steam-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon fa-lg mt-4"
  }), _c('br'), _vm._v("stumbleupon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon-circle fa-lg mt-4"
  }), _c('br'), _vm._v("stumbleupon-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tencent-weibo fa-lg mt-4"
  }), _c('br'), _vm._v("tencent-weibo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-trello fa-lg mt-4"
  }), _c('br'), _vm._v("trello\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor fa-lg mt-4"
  }), _c('br'), _vm._v("tripadvisor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tumblr fa-lg mt-4"
  }), _c('br'), _vm._v("tumblr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-tumblr-square fa-lg mt-4"
  }), _c('br'), _vm._v("tumblr-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitch fa-lg mt-4"
  }), _c('br'), _vm._v("twitch\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-lg mt-4"
  }), _c('br'), _vm._v("twitter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-lg mt-4"
  }), _c('br'), _vm._v("twitter-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-usb fa-lg mt-4"
  }), _c('br'), _vm._v("usb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-viacoin fa-lg mt-4"
  }), _c('br'), _vm._v("viacoin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vimeo fa-lg mt-4"
  }), _c('br'), _vm._v("vimeo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vimeo-square fa-lg mt-4"
  }), _c('br'), _vm._v("vimeo-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vine fa-lg mt-4"
  }), _c('br'), _vm._v("vine\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-vk fa-lg mt-4"
  }), _c('br'), _vm._v("vk\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wechat fa-lg mt-4"
  }), _c('br'), _vm._v("wechat "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-weibo fa-lg mt-4"
  }), _c('br'), _vm._v("weibo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-weixin fa-lg mt-4"
  }), _c('br'), _vm._v("weixin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp fa-lg mt-4"
  }), _c('br'), _vm._v("whatsapp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wikipedia-w fa-lg mt-4"
  }), _c('br'), _vm._v("wikipedia-w\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-windows fa-lg mt-4"
  }), _c('br'), _vm._v("windows\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wordpress fa-lg mt-4"
  }), _c('br'), _vm._v("wordpress\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-xing fa-lg mt-4"
  }), _c('br'), _vm._v("xing\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-xing-square fa-lg mt-4"
  }), _c('br'), _vm._v("xing-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator fa-lg mt-4"
  }), _c('br'), _vm._v("y-combinator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator-square fa-lg mt-4"
  }), _c('br'), _vm._v("y-combinator-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yahoo fa-lg mt-4"
  }), _c('br'), _vm._v("yahoo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yc fa-lg mt-4"
  }), _c('br'), _vm._v("yc "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yc-square fa-lg mt-4"
  }), _c('br'), _vm._v("yc-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-yelp fa-lg mt-4"
  }), _c('br'), _vm._v("yelp\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube fa-lg mt-4"
  }), _c('br'), _vm._v("youtube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-youtube-square fa-lg mt-4"
  }), _c('br'), _vm._v("youtube-square\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success mt-4"
  }, [_c('ul', {
    staticClass: "margin-bottom-none padding-left-lg"
  }, [_c('li', [_vm._v("All brand icons are trademarks of their respective owners.")]), _vm._v(" "), _c('li', [_vm._v("The use of these trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.")]), _vm._v(" "), _c('li', [_vm._v("Brand icons should only be used to represent the company or product to which they refer.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    attrs: {
      "id": "medical"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-lg mt-4"
  }), _c('br'), _vm._v("ambulance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-h-square fa-lg mt-4"
  }), _c('br'), _vm._v("h-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart fa-lg mt-4"
  }), _c('br'), _vm._v("heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heart-o fa-lg mt-4"
  }), _c('br'), _vm._v("heart-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat fa-lg mt-4"
  }), _c('br'), _vm._v("heartbeat\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o fa-lg mt-4"
  }), _c('br'), _vm._v("hospital-o\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-medkit fa-lg mt-4"
  }), _c('br'), _vm._v("medkit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-square fa-lg mt-4"
  }), _c('br'), _vm._v("plus-square\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope fa-lg mt-4"
  }), _c('br'), _vm._v("stethoscope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-user-md fa-lg mt-4"
  }), _c('br'), _vm._v("user-md\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3 col-lg-2"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair fa-lg mt-4"
  }), _c('br'), _vm._v("wheelchair\n        ")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0c11f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/icons/FontAwesome.vue
// module id = 970
// module chunks = 1